import type { TextDirection } from "@yjsgames/i18n";
import { resolveOriginX } from "./directionalUi.js";

/** 행 프레임 안쪽 버튼 여백(px) — 버튼이 프레임 stroke를 덮지 않는 최소 간격. 스탯/환생/상점 행 공용 SSoT. */
export const BUTTON_FRAME_MARGIN = 6;

/**
 * 행 프레임(origin 0.5 rect) **안쪽**에 끝단 정렬되는 버튼 중심 x — LTR=프레임 우측, RTL=좌측.
 * 버튼 x를 독립 inset(JSON 노브)이 아니라 프레임 경계에서 파생시켜 "버튼이 프레임 밖으로 삐져나오는"
 * 침범을 구조적으로 차단한다(노브가 없으므로 설정 실수 자체가 불가능 — 2026-06-12 스탯/환생 여백 0 회귀 계기).
 */
export function frameButtonX(
  frame: { x: number; width: number },
  buttonWidth: number,
  dir: TextDirection,
): number {
  return dir === "rtl"
    ? frame.x - frame.width / 2 + BUTTON_FRAME_MARGIN + buttonWidth / 2
    : frame.x + frame.width / 2 - BUTTON_FRAME_MARGIN - buttonWidth / 2;
}

/** "좌측 라벨 + 우측 버튼" 행 레이아웃 좌표 — 방향에 맞춰 미러. */
export interface LabelButtonRow {
  /** 좌측 라벨/값 기준 x (origin `textOriginX`). LTR=좌측, RTL=우측. */
  readonly textX: number;
  /** 텍스트 origin x — LTR 0(좌) / RTL 1(우). */
  readonly textOriginX: number;
  /** 우측 버튼/비용 중심 x (origin 0.5). LTR=우측, RTL=좌측. */
  readonly buttonX: number;
}

/**
 * "좌측 라벨 + 우측 버튼" 행 레이아웃 — 상점/스탯/환생 탭 공용. LTR 값은 기존 하드코딩과 동일(회귀 0),
 * RTL이면 라벨은 우측 정렬·버튼은 좌측으로 미러.
 * @param buttonInset 버튼 중심의 끝단 거리 — LTR이면 우측 끝에서, RTL이면 좌측 끝에서 같은 거리.
 */
export function computeLabelButtonRow(
  x: number,
  width: number,
  buttonInset: number,
  dir: TextDirection,
): LabelButtonRow {
  const rtl = dir === "rtl";
  return {
    textX: rtl ? x + width : x,
    textOriginX: resolveOriginX(dir),
    buttonX: rtl ? x + buttonInset : x + width - buttonInset,
  };
}
